import "./MGMySubscriptions.css"
import { MGMySubscriptionDetailCardType } from "./MGMySubscriptionDetailCardType"
import formatDatePT from "../../utils/formatDatePT";

export default function MGMySubscriptionDetailCard(
    {
        subscriptionNumber,
        subscriptionID,
        subscriptionDate,
        canReapply,
        canReinforce,
        rightAmount,
        leftAmount,
        subscriptionDetailCardType = MGMySubscriptionDetailCardType.SAVING | MGMySubscriptionDetailCardType.PROTECTION | MGMySubscriptionDetailCardType.SAVING_PLUS_PROTECTION,
        onClick
    }
) {

    const saving = () => {
        return (
            <div className="MGModalityCardDetail-amount-container">
                <session className="MGModalityCardDetail-amount" >
                    <h6>Montante aplicado</h6>
                    <h5 style={{ color: "#222324" }}>{new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(leftAmount)}</h5>
                </session>
                <hr className="MGModalityCardDetail-separator" />
                <session className="MGModalityCardDetail-amount" >
                    <h6>Rendimento bruto</h6>
                    <h5 style={{ color: "#55772A" }}>+ {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(rightAmount)}</h5>
                </session>
            </div>
        );
    }

    const protection = () => {
        return (
            <div className="MGModalityCardDetail-amount-container">
                <session className="MGModalityCardDetail-amount" >
                    <h6>Capital Subscrito</h6>
                    <h5 style={{ color: "#222324" }}>{new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(leftAmount)}</h5>
                </session>
                <hr className="MGModalityCardDetail-separator" />
                <session className="MGModalityCardDetail-amount" >
                    <h6>Entrega periódica</h6>
                    <h5 style={{ color: "#222324" }}>{new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(rightAmount)}</h5>
                </session>
            </div>
        );
    }

    const savingProtection = () => {
        return (
            <div className="MGModalityCardDetail-amount-container">
                <session className="MGModalityCardDetail-amount" >
                    <h6>Capital Subscrito</h6>
                    <h5 style={{ color: "#222324" }}>{new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(leftAmount)}</h5>
                </session>
                <hr className="MGModalityCardDetail-separator" />
                <session className="MGModalityCardDetail-amount" >
                    <h6>Entrega periódica</h6>
                    <h5 style={{ color: "#222324" }}>{new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(rightAmount)}</h5>
                </session>
            </div>
        );
    }

    const content = () => {
        switch (subscriptionDetailCardType) {
            case MGMySubscriptionDetailCardType.PROTECTION:
                return protection();
            case MGMySubscriptionDetailCardType.SAVING:
                return saving();
            case MGMySubscriptionDetailCardType.SAVING_PLUS_PROTECTION:
                return savingProtection();
            default:
                break;
        }
    }

    return (
        <div className='MGMySubscriptions-card'>
            <div className='MGMySubscriptions-title'>
                <h6>Inscrição N.º {subscriptionNumber}</h6>
                <p>Data subscrição  {formatDatePT(subscriptionDate)}</p>
            </div>
            <div>
                {content()}
            </div>
        </div>
    );
}